module.exports = __webpack_public_path__ + "static/bitmap@3x-48bf89e6cccb5268e9099ccc6e5236ff.png";